export default __webpack_public_path__ + "static/media/rtrs.4263c83c.png";